module.exports = __webpack_public_path__ + "static/media/message.902644b9.wav";